import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Class representing the ReportsCustomerView.
 * @extends JetView
 */
export default class ReportsCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Height of the tab bar
                            tabMinWidth: 190, // Minimum width of tabs
                            tabMoreWidth: 80, // Width of 'more' tab
                            /**
                             * Template for the 'more' tab.
                             * @returns {string} HTML string for the 'more' tab.
                             */
                            moreTemplate: function () {
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Localized text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                {
                                    id: 'agent.reports.userAfilliatesReport', // ID for the report option
                                    value: _('Usuarios Afiliados'), // Localized value for the option
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'agent.reports.userAfilliatesReport',
                                        'Menu',
                                    ),
                                    css: 'prm-agent.reports.userAfilliatesReport', // CSS class for styling
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
